import axios from "axios";
import {useSetRecoilState} from "recoil";
import { LOADING } from "./FinesSecurityRecoil";
import { useContext } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../util/state/globalVariables";
import { setSnackbar } from "../../../util/state/globalAction";
import { useTranslation } from "react-i18next";

export const useFinesSecurityApi = () => {
    const setLoading = useSetRecoilState(LOADING);
    const { dispatchGlobalData } = useContext(GlobalContext);
    const { t } = useTranslation(['finessecurity', 'translation']);

    const ERROR_SNACKBAR = {
        type: setSnackbar,
        payload: {
            snackbar: {
                message: t('finessecurity:clientCallFailMessage'),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
            }
        }
    };

    const onSuccess = function (response: any) {
        setLoading(false);
        return response.data;
    }

    const onError = function (error: any) {
        setLoading(false);
        dispatchGlobalData(ERROR_SNACKBAR);
        console.error('Request Failed:', error.config);
        if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
            console.error('Headers:', error.response.headers);
        } else {
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    }

    const GET = (url: string, loading: boolean, config?: any) => {
        if (loading) {
            setLoading(true);
        }
        return axios.get(url, config).then(onSuccess).catch(onError);
    }

    const POST = (url: string, payload: any, loading: boolean, config?: any) => {
        if (loading) {
            setLoading(true);
        }
        return axios.post(url, payload, config).then(onSuccess).catch(onError)
    }

    const PUT = (url: string, payload: any, loading: boolean, config?: any) => {
        if (loading) {
            setLoading(true);
        }
        return axios.put(url, payload, config).then(onSuccess).catch(onError)
    }

    return { GET, POST, PUT }

}